/*
 * @Author: sail web admin
 * @Date: 2020-05-07 10:18:45
 * @Last Modified by: sail web admin
 * @Last Modified time: 2020-05-07 10:49:04
 * 登录模块中文
 */
export default {
  Login: '登 录',
  AdministratorLogin: '管理员登录',
  MobileNumber: '手机号',
  SMSVerificationCode: '短信验证码',
  GetCode: '获取验证码',
  Resend: '秒重新发送'
};
